import React from "react";
import { Card, Col, Row} from "react-bootstrap";
import MasterChart from "../../Master.charts";
import LoadWraper from "components/LoadWraper";

const MasterCharts = React.memo(({ isPendingMaster, masterData }) => {
  const chartConfigs = [
    {
      title: "Software Wise Masters",
      condition: masterData?.mastersBySoftware?.length > 0,
      content: (
        <MasterChart
          masterData={masterData?.mastersBySoftware || []}
          dataKey="TotalRecors"
          titleKey="Software"
          label="Masters Count"
          color="#8884d8"
          barSize={40}
        />
      ),
    },
    {
      title: "Subarea Wise Count",
      condition: masterData?.subareaCounts?.length > 0,
      content: (
        <MasterChart
          masterData={masterData?.subareaCounts || []}
          dataKey="TotalRecors"
          titleKey="SubareaId"
          label="Subarea Count"
          color="#82ca9d"
          barSize={30}
        />
      ),
    },
    {
      title: "CSC Id Wise Count",
      condition: masterData?.cscWise?.length > 0,
      content: (
        // <SystemSumarryChart
        //   masterData={masterData?.cscWise || []}
        // />
        <MasterChart
          masterData={masterData?.cscWise || []}
          dataKey="Count"
          titleKey="CSCId"
          label="Subarea Count"
          color="#82ca9d"
          barSize={30}
        />
      ),
    },
  ];

  return (
    <Row className="mb-4 gx-3 gy-4">
      {chartConfigs.map((card, index) => (
        <Col md={4} key={index}>
          <Card className="shadow-lg h-100 dashbaord-card">
            <Card.Body className="graph-card-body d-flex flex-column">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <Card.Title>{card.title}</Card.Title>
              </div>
              <div className="flex-grow-1 d-flex justify-content-center align-items-center">
                <LoadWraper isload={isPendingMaster}>
                  {card.condition ? (
                    card.content
                  ) : (
                    <div className="text-muted text-center">
                      No data available
                    </div>
                  )}
                </LoadWraper>
              </div>
            </Card.Body>
          </Card>
        </Col>
      ))}
    </Row>
  );
});

export default MasterCharts;